import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { chartNames } from "../../../../consts";
import { dashboardUtil } from "../../../../utils";
import { useSelectedAppTypes } from "../../../../hooks";

import DeviceConnectionsCountChart from "../defaultCharts/DeviceConnectionsCountChart";
import ADStatisticsChart from "../defaultCharts/ADStatisticsChart";
import FWUStatisticsChart from "../defaultCharts/FWUStatisticsChart";
import SettingUsageChart from "../defaultCharts/SettingUsageChart";
import { GridItem } from "../styled";

const DefaultSection = ({
  getChartFilter = () => {},
  getIsLoading = () => {},
  getIsError = () => {},
  downloadCSV = () => {}
}) => {
  const connectionsByMarket = useSelector((store) => store.rum.connectionsByMarket);
  const diagnostics = useSelector((store) => store.rum.diagnostics);
  const fwu = useSelector((store) => store.rum.fwu);
  const settings = useSelector((store) => store.rum?.settings);

  const selectedAppTypes = useSelectedAppTypes();

  return (
    <>
      {dashboardUtil.isChartAvailable(
        selectedAppTypes,
        chartNames.IQOS_DEVICE_CONNECTIONS_COUNT
      ) && (
        <GridItem gridColumn={"1 / 7"}>
          <DeviceConnectionsCountChart
            connectionsByMarket={connectionsByMarket}
            getChartFilter={getChartFilter}
            getIsLoading={getIsLoading}
            getIsError={getIsError}
          />
        </GridItem>
      )}

      {dashboardUtil.isChartAvailable(selectedAppTypes, chartNames.AD_STATISTICS) && (
        <GridItem gridColumn={"1 / 7"}>
          <ADStatisticsChart
            diagnostics={diagnostics}
            getChartFilter={getChartFilter}
            getIsLoading={getIsLoading}
            getIsError={getIsError}
          />
        </GridItem>
      )}

      {dashboardUtil.isChartAvailable(selectedAppTypes, chartNames.FWU_STATISTICS) && (
        <GridItem gridColumn={"1 / 7"}>
          <FWUStatisticsChart
            fwu={fwu}
            getChartFilter={getChartFilter}
            getIsLoading={getIsLoading}
            getIsError={getIsError}
            downloadCSV={downloadCSV}
          />
        </GridItem>
      )}

      {dashboardUtil.isChartAvailable(selectedAppTypes, chartNames.SETTING_USAGE) && (
        <GridItem gridColumn={"1 / 7"}>
          <SettingUsageChart
            settings={settings}
            getChartFilter={getChartFilter}
            getIsLoading={getIsLoading}
            getIsError={getIsError}
          />
        </GridItem>
      )}
    </>
  );
};

DefaultSection.propTypes = {
  getChartFilter: PropTypes.func.isRequired,
  getIsLoading: PropTypes.func.isRequired,
  getIsError: PropTypes.func.isRequired,
  downloadCSV: PropTypes.func.isRequired
};

export default DefaultSection;
